import { SyntheticEvent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, Modal, ModalProps, TextField } from 'components'

import styles from './Members.module.scss'

interface InviteModalProps extends Pick<ModalProps, 'onClose' | 'open'> {
  inviteUser: (email: string) => void
  inviteUserError?: string
}

const InviteModal = ({ inviteUser, inviteUserError, open, ...modalProps }: InviteModalProps) => {
  const { t } = useTranslation('settings')

  const [email, setEmail] = useState('')

  useEffect(() => setEmail(''), [open])

  const handleInviteUser = (event: SyntheticEvent) => {
    event.preventDefault()
    inviteUser(email)
  }

  return (
    <Modal
      actions={
        <>
          <Button onClick={modalProps.onClose} variant="secondary">
            {t('users.invite.cancel')}
          </Button>
          <Button disabled={!email.trim()} type="submit">
            {t('users.invite.save')}
          </Button>
        </>
      }
      className={styles.modal}
      contentClassName={styles.modalContent}
      onSubmit={handleInviteUser}
      open={open}
      title={t('users.invite.title')}
      {...modalProps}
    >
      <label className={styles.field}>
        <span>{t('users.invite.email.title')}</span>
        <TextField
          autoFocus
          className={styles.emailInput}
          error={inviteUserError}
          onChange={setEmail}
          placeholder={t('users.invite.email.placeholder')}
          value={email}
        />
        <small>{t('users.invite.email.hint')}</small>
      </label>
    </Modal>
  )
}

export default InviteModal
